import type { GameVariant } from '@draughts/shared';

/**
 * Una lista di varianti con la PREFERITA dell'utente in testa, il resto
 * nell'ordine canonico di `ACTIVE_VARIANTS`.
 *
 * Le due griglie di card delle regole — l'indice e «Altre varianti» in fondo
 * alla pagina di una variante — mostravano sempre l'Internazionale per prima,
 * perche' l'ordine canonico e' uguale per tutti: chi gioca a un'altra variante
 * doveva cercarsi la sua card in mezzo alle ventiquattro, su mobile spesso
 * sotto la piega.
 *
 * `preferred` e' la stringa MINUSCOLA dello store delle preferenze
 * ('italian', 'south_african'), i `variants` sono membri dell'enum
 * ('ITALIAN'): il confronto e' un `toLowerCase()` per lato, esattamente la
 * trasformazione con cui `getVariantString` genera `PREFERRED_VARIANTS`.
 *
 * NON usa `toGameVariant`: quella fa fallback su INTERNATIONAL per ogni
 * stringa che non riconosce, e metterebbe in cima proprio la card sbagliata
 * nel caso da proteggere. Qui una preferita assente, vuota o ignota lascia la
 * lista com'e'.
 *
 * Solo tipi importati: questo modulo finisce anche nel prerender SSR.
 */
export function variantsPreferredFirst(
  variants: readonly GameVariant[],
  preferred?: string | null,
): GameVariant[] {
  if (!preferred) return [...variants];
  const wanted = preferred.toLowerCase();
  const first = variants.find((v) => v.toLowerCase() === wanted);
  if (!first) return [...variants];
  return [first, ...variants.filter((v) => v !== first)];
}
